import React from 'react';
import './DesktopSiteAssetListPage.scss';
import {
    List,
    LastActiveCell,
    StandardListCell,
    StateListCell,
    SensorDataListCell,
    DataTypeListCell,
    DeviceCategoryListCell,
    StateOptions,
    Icon,
    Tooltip
} from "gd-react";
import SiteAssetListPage from "./SiteAssetListPage";
import GettingStarted from "../../components/GettingStarted";
import GenericLoader from "../../components/GenericLoader";
import IssuePopover from "../../components/IssuePopover/IssuePopover";
import VirtualChildrenPopover from "../../components/VirtualChildrenPopover/VirtualChildrenPopover";
import EditVirtualChildrenButton from "../../components/EditVirtualChildren/StatusPie";
import StatusPie from "../../components/EditVirtualChildren/StatusPie";

class DesktopSiteAssetListPage extends SiteAssetListPage {

    render() {

        let assets;
        let noDevicePage;
        if (this.props.hubs) {
            noDevicePage =
                <GettingStarted permission={this.state.orgPermission}
                                closed={{one: true, two: true, three: this.props.hubs.list.length}}/>
        }
        let filters;

        if (this.props.item) {
            if (this.props.filterType === 'site_id') {
                filters = [
                    {
                        field: 'siteId',
                        value: this.props.item.id
                    },
                    {
                        field: 'locationId',
                        value: this.props.item.locationId
                    },
                    {
                        field: 'parentAsset',
                        value: null
                    },
                ];
            } else if (this.props.filterType === 'site_group_id') {
                filters = [
                    {
                        field: 'siteGroupId',
                        value: this.props.item.id
                    }, {
                        field: 'parentAsset',
                        value: null
                    },
                ];
            } else if (this.props.filterType === 'org_partner_id') {
                filters = [
                    {
                        field: 'orgPartnerId',
                        value: this.props.item.id
                    }, {
                        field: 'parentAsset',
                        value: null
                    },
                ];
            } else if (this.props.filterType === 'asset_id' && this.props.type === 'hub') {

                filters = [
                    {
                        field: 'gatewayId',
                        value: this.props.item.id
                    }
                ]
            }

            let columns = [
                {
                    component: StandardListCell,
                    bold: true,
                    sortable: true,
                    title: 'Name',
                    field: 'name',
                    endAdornment: function (item) {
                        const so = StateOptions.find(so => so.type === item.sku);
                        if (!so) return;
                        const icon = so.icon;
                        if (item.sku === 'VIRTUAL-PARENT-MERGED') {
                            return icon &&
                                <Tooltip position={'top'} label={so.label}><VirtualChildrenPopover item={item}><Icon
                                    icon={icon} size={'18'}/></VirtualChildrenPopover></Tooltip>
                        } else {
                            return <Tooltip position={'top'} label={so.label}><Icon
                                icon={icon} size={'18'}/></Tooltip>
                        }
                    }
                },
                // {
                //     component: DataTypeListCell,
                //     title: 'Data Type',
                //     field: 'dataType',
                //     sortable: true,
                //     defaultSort: 'desc'
                // },
                {
                    component: SensorDataListCell, title: 'Data',
                    field: 'temperature'
                },
                {
                    component: DeviceCategoryListCell,
                    title: 'Device Category',
                    field: 'deviceCategory',
                    sortable: true,
                    defaultSort: 'desc'
                },
                {
                    component: StateListCell,
                    endAdornment: (object) => {
                        return <IssuePopover
                            type={'Asset'}
                            updateDisconnectedDrawer={this.props.updateFunctions.updateDisconnectedDrawer}
                            item={object}/>
                    },
                    sortable: false,
                    title: 'Status',
                    field: 'currentState',
                    showLabel: true,
                    permission: this.state.orgPermission,
                    customStatus: (item) => {
                        if (!item?.sku) return {valid: false};
                        return {
                            valid: item.sku.indexOf('VIRTUAL-PARENT') !== -1,
                            component: item.sku === 'VIRTUAL-PARENT' ? '' :
                                <VirtualChildrenPopover item={item}><StatusPie item={item}/></VirtualChildrenPopover>
                        }
                    }
                },
                {component: LastActiveCell, title: 'Last Active', field: 'lastContacted', maxWidth: 'none'}
            ];

            if (this.props.filterType !== 'site_id') {
                columns.splice(1, 0,
                    {component: StandardListCell, bold: true, sortable: true, title: 'Site', field: 'siteName'},)
            }

            assets =
                (<List
                        noitemelem={noDevicePage}
                        searchable
                        sortby={{
                            field: 'name',
                            type: 'asc'
                        }}
                        // itemsPerPage={5}
                        columns={columns}
                        rowOnClick={this.goToAsset}
                        getlist={this.getList}
                        parentField={this.props.type === 'hub' ? null : "parentAsset"}
                        childrenField={this.props.type === 'hub' ? null : "children"}
                        expanded={this.props.type !== 'hub'}
                        filters={filters}
                    />
                )
        }
        return (
            <div className='page'>
                {this.props.loaded ? assets : <GenericLoader/>}
            </div>
        );
    }
}

export default DesktopSiteAssetListPage;
